/**
 * Cross-cutting numeric / string constants. Co-locating them here keeps
 * tweaks one-place and lets unit tests import the same values the runtime
 * uses (avoids "magic number" drift between code and assertions).
 *
 * Each constant carries a one-line "why" — see architecture.md for the
 * full rationale.
 */

/**
 * Initial reconnect delay for the global SSE channel (`useSSE`).
 * Doubles after every failure up to {@link SSE_BACKOFF_MAX_MS}.
 * 2s is short enough that a transient blip feels instant; doubling from
 * here reaches 60s after 5 failures (2 → 4 → 8 → 16 → 32 → 60), which
 * matches the legacy `connectSSE()` cadence (architecture §3.4, PAIN_POINTS #9).
 */
export const SSE_BACKOFF_INITIAL_MS = 2_000

/**
 * Hard cap on SSE reconnect delay. After 5 consecutive failures the hook
 * keeps retrying every 60s indefinitely — this is the "server is down"
 * regime where polling more aggressively just spams the box without
 * shortening the recovery window.
 */
export const SSE_BACKOFF_MAX_MS = 60_000
